module.exports = __webpack_public_path__ + "img/SelectCamera.943badf1.png";